/**
 * Labstep
 *
 * @module grid/Report/components/ColumnHeader/Trigger
 * @desc Default DataGrid ColumnHeader
 */

import classnames from 'classnames';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import { useRef } from 'react';
import styles from './styles.module.scss';
import type { GridReportColumnHeaderTriggerProps } from './types';

export const GridReportColumnHeaderTrigger: React.FC<
  GridReportColumnHeaderTriggerProps
> = ({
  onClick,
  displayName,
  icon,
  cornerIcon,
  action,
  column,
  secondaryHeader,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div
      ref={ref}
      className={classnames(styles.defaultContainer, {
        [styles.clickable]: !!onClick,
      })}
      onClick={onClick}
    >
      <div className={styles.title}>
        {icon && <Icon name={icon} cornerIcon={cornerIcon} />}{' '}
        <Flex column>
          {displayName}
          {secondaryHeader && (
            <span className={styles.secondaryHeader}>
              {secondaryHeader}
            </span>
          )}
        </Flex>
        <div className={styles.sort}>
          {column.getSort() === 'asc' && (
            <Icon name="long arrow alternate up" />
          )}
          {column.getSort() === 'desc' && (
            <Icon name="long arrow alternate down" />
          )}
        </div>
      </div>
      {action}
    </div>
  );
};
